module.exports = __webpack_public_path__ + "static/media/settingsact.430133d3.svg";